<script setup lang="ts">
import { defineProps, computed } from "vue";
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  faqTemplateName: string;
  title: string;
  collapseButtonText: string;
}>();

const { tm } = useI18n();

const faq = computed(() => tm(props.faqTemplateName));

const getParagraphClass = (nextItem?: any) => {
  if (!nextItem) return "";
  if (nextItem.type === "list") return "mb-4";
  if (nextItem.type === "paragraph") return "mb-6";
  if (nextItem.type === "subtitle") return "mb-6";
  return "";
};

const getListCLass = (nextItem?: any) => {
  if (!nextItem) return "";
  if (nextItem.type !== "title") return "mb-6";
  return "";
};
</script>

<template>
  <AccordionComponent>
    <template #title>
      {{ props.title }}
    </template>
    <template #faq-content>
      <div class="text-brown font-normal text-xl leading-[28px]">
        <template v-for="(item, index) in faq" :key="index">
          <template v-if="item.type === 'title'">
            <div class="w-full h-px bg-ternary my-8" v-if="index > 0"></div>
            <h4 class="activation-title mb-[20px]">{{ item.content }}</h4>
          </template>
          <h5 v-else-if="item.type === 'subtitle'" class="mb-4 font-semibold">
            {{ item.content }}
          </h5>

          <p
            v-else-if="item.type === 'paragraph'"
            :class="getParagraphClass(faq[index + 1])"
          >
            <span v-if="typeof item.content === 'string'">
              {{ item.content }}
            </span>

            <template
              v-else
              v-for="(seq, seqIndex) in item.content"
              :key="seqIndex"
            >
              <span :class="{ 'font-bold': seq.type === 'bold' }">
                {{ seq.text }}
              </span>
            </template>
          </p>

          <ul
            v-else-if="item.type === 'list'"
            class="list-disc pl-6 space-y-2"
            :class="getListCLass(faq[index + 1])"
          >
            <li
              v-for="(element, elementIndex) in item.content"
              :key="elementIndex"
            >
              <span v-if="typeof element === 'string'">
                {{ element }}
              </span>

              <template
                v-else
                v-for="(elementSeq, seqIndex) in element"
                :key="seqIndex"
              >
                <span :class="{ 'font-bold': elementSeq.type === 'bold' }">
                  {{ elementSeq.text }}
                </span>
              </template>
            </li>
          </ul>
        </template>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ props.collapseButtonText }}
    </template>
  </AccordionComponent>
</template>

<style scoped>
.activation-title {
  @apply font-semibold text-2xl leading-[32px];
}
</style>
